"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBorderSection = void 0;
var tslib_1 = require("tslib");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
exports.StyledBorderSection = styled_1.default.section(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  label: BorderSection;\n\n  border-radius: 8px;\n  box-shadow: 0 4px 24px 0 rgba(79, 86, 97, 0.05);\n  height: fit-content;\n  background-color: #fff;\n  transition: 0.3s cubic-bezier(0.33, 1, 0.68, 1);\n\n  border: 1px solid #dce0e8;\n\n  ", "\n"], ["\n  label: BorderSection;\n\n  border-radius: 8px;\n  box-shadow: 0 4px 24px 0 rgba(79, 86, 97, 0.05);\n  height: fit-content;\n  background-color: #fff;\n  transition: 0.3s cubic-bezier(0.33, 1, 0.68, 1);\n\n  border: 1px solid #dce0e8;\n\n  ",
    "\n"])), function (props) {
    return props.addHoverCss
        ? "\n          &:hover {\n            background-color: #f7f7fa;\n            box-shadow: 0 8px 36px 0 rgba(79, 86, 97, 0.1);\n          }\n        "
        : '';
});
var templateObject_1;
